export default "__VITE_ASSET__72407709__"